<template>
  <div class="page">
    <div class="page-title">我的模板</div>
    <a-list :loading="loading" :data-source="myModuleList"
            :grid="{ gutter: 24, xxl: 4, xl: 3, lg: 2, md: 2, sm: 2, xs: 1 }">
      <a-list-item slot="renderItem" slot-scope="item">
        <a-card class="ant-pro-pages-account-projects-card" hoverable>
          <div class="image-box" slot="cover" @click="previewImg(item.templateImg)">
            <img :src="item.templateImg" alt=""/>
          </div>
          <a-card-meta :title="item.templateName">
            <template slot="description">{{ item.templateDesc }}</template>
          </a-card-meta>
          <div class="cardItemContent">
            <span>{{ item.templateStatusStr }}</span>
            <a v-if="item.templateStatus===1||item.templateStatus===0" @click="showModal(item)">立即设置</a>
          </div>
        </a-card>
      </a-list-item>
    </a-list>
    <!-- 图片预览 -->
    <PreviewImage v-if="imgDialogVisible" :dialogVisible="imgDialogVisible" :imageUrl="imageUrl"
                  @close="closeData"></PreviewImage>
    <a-modal title="模板设置"
             width="800px"
             :visible="visible"
             @ok="handleSubmit"
             @cancel="visible = false"
    >
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="搜索框提示文字">
          <a-input style="width: 400px;" v-model="ruleForm.templateSearchRemindWord" :maxLength='16'
                   placeholder="请输入"></a-input>
        </a-form-model-item>
        <a-form-model-item label="平台模式">
          <a-radio-group name="radioGroup" v-model="ruleForm.templatePlatformType">
            <a-radio :value="1">
              全站模式
            </a-radio>
            <a-radio :value="2">
              多城市分站模式
            </a-radio>
            <a-radio :value="3">
              全球定位模式
            </a-radio>
          </a-radio-group>
        </a-form-model-item>
        <div v-if="ruleForm.templatePlatformType===2">
          <a-form-model-item label="选择已开分站" prop="areaList">
            <AreaSelected
              :areaStyle="{'width':'400px'}"
              :templateOnlyCity="true"
              area-type="in"
              :changeOnSelect="false"
              :isNewCity="true"
              @change="onCityChange"
            ></AreaSelected>
            <div>
              <template v-for="tagItem in ruleForm.areaList">
                <a-tag closable color="blue" @close="handleStaffClose(tagItem.cityId)" :key="tagItem.cityId">
                  {{ tagItem.cityName }}
                </a-tag>
              </template>
            </div>
          </a-form-model-item>
        </div>
      </a-form-model>
    </a-modal>
    <a-modal title="更新小程序模版"
             width="400px"
             :confirmLoading="updateLoading"
             :visible="showMiniProgramCommitDialog"
             @ok="updateSubmit"
             @cancel="showMiniProgramCommitDialog = false"
    >
      <a-radio-group name="radioGroup" v-model="updateType">
        <a-radio :value="1">暂不更新</a-radio>
        <a-radio :value="2">立即更新</a-radio>
      </a-radio-group>
    </a-modal>
  </div>
</template>

<script>
import PreviewImage from '../component/PreviewImage'
import AreaSelected from '@/customComponents/AreaSelected/AreaSelected'
import Vue from 'vue'
import { SET_CITY_FLAG } from '@/store/mutation-types'
import dbManager from '@/utils/indexeDb'

export default {
  name: 'MyTemplate',
  components: {
    PreviewImage,
    AreaSelected
  },
  data() {
    return {
      imgDialogVisible: false,
      imageUrl: '',
      loading: true,
      myModuleList: [],
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      visible: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      templateId: '',
      templateUseValidTime: '',
      ruleForm: {
        templatePlatformType: 1,
        areaList: [],
        templateSearchRemindWord: ''
      },
      rules: {
        areaList: [{ required: true, message: '请选择选择已开分站', trigger: ['blur', 'change'] }]
      },
      areaOptions: [],
      showMiniProgramCommitDialog: false,
      updateLoading: false,
      updateType: 1
    }
  },
  mounted() {

  },
  activated() {
    this.loading = true
    this.getMyModule()
  },
  methods: {
    checkMiniProgramCommitValid() {
      this.getHttpServices().getUserService().post('v2/wxMiniProgram/checkMiniProgramCommitValid')
        .then(data => {
          if (data && data.flag) {
            //显示更新小程序相关逻辑
            this.showMiniProgramCommitDialog = true
            this.updateType = 1
          } else if (data.msg) {
            this.$message.error(data.msg)
          }
          this.getLogUtils().logWithTag('checkMiniProgramCommitValid', data)
        }).catch(reason => {
        this.getLogUtils().errorWithTag('checkMiniProgramCommitValid', reason)
      })
    },
    handleStaffClose(removedTag) {
      if (this.ruleForm.areaList.length > 0) {
        this.ruleForm.areaList = this.ruleForm.areaList.filter(tag => tag.cityId !== removedTag)
      }
    },
    onCityChange(item) {
      let selectedOptions = item.selectedOptions
      let obj = {
        countryId: 0,
        provinceId: selectedOptions[0].value,
        provinceName: selectedOptions[0].label,
        cityId: selectedOptions[1].value,
        cityName: selectedOptions[1].label
      }
      if (this.ruleForm.areaList.length > 0) {
        let flag = false
        this.ruleForm.areaList.map(item => {
          if (item.cityId === obj.cityId) {
            this.$message.error('请勿重复添加')
            flag = true
          }
        })
        if (!flag) {
          this.ruleForm.areaList.push(obj)
        }
      } else {
        this.ruleForm.areaList.push(obj)
      }
    },
    showModal(item) {
      this.templateId = item.templateId
      this.templateUseValidTime = item.templateUseValidTime
      this.visible = true
      this.ruleForm = {
        templatePlatformType: 1,
        areaList: [],
        templateSearchRemindWord: ''
      }
      this.getTemPlateStyleInfo(item.templateId)
    },
    //获取我的模板
    getTemPlateStyleInfo(templateId) {
      this.getHttpServices().getProService().get('templateStyle/get/myTemPlateStyleInfo/' + templateId)
        .then(res => {
          this.ruleForm.templatePlatformType = res ? res.templatePlatformType : 1
          this.ruleForm.templateSearchRemindWord = res ? res.templateSearchRemindWord : ''
          this.ruleForm.areaList = res.cityVOList && res.cityVOList.length > 0 ? res.cityVOList : []
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    handleSubmit() {
      console.error('数据', this.ruleForm)
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitEvent()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    submitEvent() {
      let params = {
        templateId: this.templateId,
        templateUseValidTime: this.templateUseValidTime,
        platformId: this.platformId,
        templatePlatformType: this.ruleForm.templatePlatformType,
        templateSearchRemindWord: this.ruleForm.templateSearchRemindWord ? this.ruleForm.templateSearchRemindWord : '',
        cityVOList: this.ruleForm.areaList
      }

      this.getHttpServices().getProService().post('templateStyle/update/updateTemplateStatus', params)
        .then(res => {
          this.$message.success('设置成功')
          this.getMyModule()
          this.visible = false
          this.checkMiniProgramCommitValid()
          this.clearH5Cache()//清除H5页面相关缓存
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    },
    updateSubmit() {
      if (this.updateType === 2) {
        this.updateLoading = true
        this.getHttpServices().getUserService().post('v2/wxMiniProgram/release', { templateId: this.templateId })
          .then(res => {
            this.showMiniProgramCommitDialog = false
            this.updateType = 1
            this.$message.success('同步数据提交成功')
          })
          .catch(reason => this.showNetWorkErrorMessage(reason))
          .finally(() => {
            this.updateLoading = false
            this.showMiniProgramCommitDialog = false
          })
      } else {
        this.showMiniProgramCommitDialog = false
      }
    },
    closeData() {
      this.imageUrl = ''
      this.imgDialogVisible = false
    },
    // 点击图片预览
    previewImg(imgUrl) {
      this.imgDialogVisible = true
      this.imageUrl = imgUrl
    },
    //获取我的模板
    getMyModule() {
      this.getHttpServices().getSmsApiService().post('templateStyle/query/myTemPlateStyle', {
        platformId: this.getPlatformConfig().platformId,
        merchantId: this.merchantId
      }).then(res => {
        this.myModuleList = res
        this.loading = false
        this.getLogUtils().logWithTag('getMyModule', res)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }

}
</script>
<style lang="less" scoped>
.page {
  .page-title {
    height: 66px;
    line-height: 66px;
    background: #FFFFFF;
    border-radius: 2px;
    padding-left: 15px;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 15px;
  }

  .image-box {
    width: 100%;
    height: 230px;
    overflow: hidden;

    img {
      width: 100%;
      height: auto;
    }
  }

  /deep/ .ant-card-meta-title {
    margin-bottom: 4px;
  }

  /deep/ .ant-card-meta-description {
    height: 44px;
    overflow: hidden;
    line-height: 22px;
  }

  .cardItemContent {
    display: flex;
    height: 20px;
    margin-top: 16px;
    margin-bottom: -4px;
    line-height: 20px;

    > span {
      flex: 1 1;
      color: rgba(0, 0, 0, .45);
      font-size: 12px;
    }

    /deep/ .ant-pro-avatar-list {
      flex: 0 1 auto;
    }
  }
}
</style>